import { landingPageTours } from './landingTours';
import { dashboardTours } from './dashboardTours';
import { adminTours } from './adminTours';

// Central tour registry
const tourRegistry = {
  ...landingPageTours,
  ...dashboardTours,
  ...adminTours
};

export const getTourById = (tourId) => {
  return tourRegistry[tourId] || null;
};

export const getAllTours = () => {
  return tourRegistry;
};

export const getToursByCategory = (category) => {
  return Object.values(tourRegistry).filter(tour => tour.category === category);
};

export const getToursByRole = (role) => {
  return Object.values(tourRegistry).filter(tour => {
    return !tour.conditions?.userRole || tour.conditions.userRole === role || tour.conditions.userRole === 'any';
  });
};